import * as CryptoJS from 'crypto-js'
import { environment } from '@env'

export function encryptData(
  data: any,
  secretKey: string = environment.STORAGE_SECRET_KEY
): string {
  try {
    const dataStr = JSON.stringify(data)
    const encrypted = CryptoJS.AES.encrypt(dataStr, secretKey).toString()
    return encrypted
  } catch (error) {
    console.error('Encryption error:', error)
    throw error
  }
}

export function decryptData(
  encrypted: string,
  secretKey: string = environment.STORAGE_SECRET_KEY
): any {
  try {
    if (encrypted.startsWith('{') && encrypted.endsWith('}')) {
      return JSON.parse(encrypted)
    }

    const bytes = CryptoJS.AES.decrypt(encrypted, secretKey)
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8)

    if (!decryptedText) {
      throw new Error('Decryption failed - empty result')
    }

    return JSON.parse(decryptedText)
  } catch (error) {
    console.error('Decryption error:', error)
    return null
  }
}
